<template>
  <div class="PlanejamentoAcaoForm_Rodape">
    <v-container fluid>
      <v-row>
        <planejamento-acao-verba-variavel-form-acoes-fluxo
          ref="componenteFluxo"
          :configuracao="configuracao"
          :acao-concluir="concluirAcao"
          :valida-concluir-acao="validaConcluirAcao"
          :permite-salvar="permiteSalvar"
          :acao-edicao="acaoEdicao"
          :acao-salvar="salvar"
          :edicao="!novaAcao"
          :is-valor-pendente-zerado="isValorPendenteZerado"
          :upload-evidencia-obrigatorio="uploadEvidenciaObrigatorio"
          :ind-tem-evidencia="indTemEvidencia"
          :is-verba-variavel="true">
          <v-btn slot="acoes-padrao" @click="cancelar(true)" class="mr-3">
            {{ $t('label.voltar') }}
          </v-btn>
          <v-btn slot="acoes-padrao" @click="salvarRecarregar()"
            class="mr-3"
            dark
            color="primary"
            v-show="!somenteLeitura"
            :disabled="!permiteSalvar || desabilitarSalvar">
            {{ $t('label.salvar') }}
          </v-btn>
        </planejamento-acao-verba-variavel-form-acoes-fluxo>
      </v-row>
    </v-container>
    <confirm
      ref="cancelamentoDialog"
      :persistent="true">
    </confirm>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import PlanejamentoAcaoVerbaVariavelFormAcoesFluxo from '@/spa/planejamento-acao/form-verba-variavel/PlanejamentoAcaoVerbaVariavelFormAcoesFluxo';
import Confirm from '@/shared-components/dialog/Confirm';
import { forceLoading, forceHideLoading } from '@/common/functions/loading';

export default {
  props: {
    novaAcao: Boolean,
    somenteLeitura: Boolean,
    acaoEdicao: Object,
    isCopiaAcao: Boolean,
    copiaAcao: Object,
    indTemEvidencia: Boolean,
    isValorPendenteZerado: Boolean,
    validaSalvar: Function,
    getObjetoFormatado: Function,
    salvarNovoBudgetId: Function,

    configuracao: {
      type: Object,
      required: true,
    },
  },
  components: {
    Confirm,
    PlanejamentoAcaoVerbaVariavelFormAcoesFluxo,
  },
  data() {
    return {
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      salvandoAcao: false,
      desabilitarSalvar: false,
    };
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    isAmbienteMagalu() {
      return this.chaveEmpresa === 'MAGALU';
    },
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
    isUsuarioFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    permiteSalvar() {
      return (
        !this.acaoEdicao.status
        || this.acaoEdicao.status === 'EM_CADASTRO'
      );
    },
    uploadEvidenciaObrigatorio() {
      return this.configuracao
        && this.configuracao.configuracao
        && this.configuracao.configuracao.passo1
        && this.configuracao.configuracao.passo1.uploadObrigatorio;
    },

  },
  methods: {
    exibeCampoRateioEntreTiposDeUso(acao) {
      return this.isAmbienteKabum
        && this.configuracao.indHabilitarRateioContabil
        && (acao.calculoBonificacao
        && acao.calculoBonificacao === 'VALOR_FIXO')
        && !this.isUsuarioFornecedor;
    },
    carregaInformacoesFluxo(idAcao) {
      if (this.$refs.componenteFluxo) {
        this.$refs.componenteFluxo.carregaInformacoesFluxo(idAcao);
      }
    },
    salvarAntesDeSolicitar() {
      if (this.$refs.componenteFluxo) {
        this.$refs.componenteFluxo.salvarAntesDeSolicitar();
      }
    },
    validaAntesDeSalvar(isSolicitandoAprovacao) {
      return this.validaSalvar(isSolicitandoAprovacao);
    },
    salvarRecarregar() {
      forceLoading();
      this.salvar()
        .then((idAcao) => {
          forceHideLoading();
          if (idAcao !== null) {
            this.alternaRota(idAcao);
          }
        })
        .catch((err) => {
          if (err) {
            this.$toast(err.data.error);
            forceHideLoading();
          }
        });
    },
    async salvar(isSolicitandoAprovacao = false) {
      if (this.salvandoAcao) return {};
      this.salvandoAcao = true;
      forceLoading();

      if (!this.validaAntesDeSalvar(isSolicitandoAprovacao)) {
        forceHideLoading();
        this.salvandoAcao = false;
        return Promise.reject();
      }

      const acao = this.getObjetoFormatado();
      acao.linhasProduto.forEach((linhaProduto) => {
        linhaProduto.valor = Number(linhaProduto.valor).toFixed(2);
      });

      try {
        if (this.exibeCampoRateioEntreTiposDeUso(acao)) {
          await this.salvarNovoBudgetId();
        }

        if (this.novaAcao || this.isCopiaAcao) {
          return await this.salvarNovo(acao);
        }
        return await this.atualizar(acao, isSolicitandoAprovacao);
      } finally {
        this.salvandoAcao = false;
        forceHideLoading();
      }
    },
    salvarNovo(acao) {
      return this.planejamentoAcaoResource.salvarAcaoVerbaVariavel(acao)
        .then((res) => {
          this.$toast(this.$t('message.adicionado_confira_tabela'));
          const idAcao = res.data;
          forceHideLoading();
          return idAcao;
        });
    },
    atualizar(acao, isSolicitandoAprovacao) {
      acao.mapaCamposDinamicos.prazo_pag_avulsa = acao.prazoVencimentoAcao;
      this.acaoEdicao.indPossuiPassoFornecedor = acao.indPossuiPassoFornecedor;
      return this.planejamentoAcaoResource.atualizarAcaoVerbaVariavel(acao)
        .then((res) => {
          if (!isSolicitandoAprovacao) {
            this.$toast(this.$t('message.acao_atualizada'));
          }
          const idAcao = res.data;
          forceHideLoading();
          return idAcao;
        });
    },
    alternaRota(idAcao) {
      const routeEdicao = 'editarAcaoVerbaVariavel';

      let { name } = this.$router.currentRoute;
      name = name === routeEdicao
        ? name.concat('_') : routeEdicao;

      this.$router.replace({
        name,
        params: {
          idAcao, novaAcao: this.novaAcao, from: 'detalharAcaoVerbaVariavel',
        },
      });
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
    },
    validaConcluirAcao() {
      forceLoading();
      if (!this.validaAntesDeSalvar(true)) {
        forceHideLoading();
        return false;
      }
      forceHideLoading();
      return true;
    },
    concluirAcao() {
      forceLoading();
      const acao = this.formataAcaoParaEnvio();
      return this.planejamentoAcaoResource.concluirAcao(acao)
        .then((res) => this.alternaRota(res.data))
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    cancelar(forceVoltaParaLista = false) {
      if (this.somenteLeitura) {
        if (this.$route.params.from && this.$route.params.modalDashboard && this.$route.params.from === 'dashboard-inicial') {
          this.$router.push({ name: this.$route.params.from, params: { modalDashboard: this.$route.params.modalDashboard } });
        } else {
          this.$router.push({
            name: this.$route.params.from || 'planejamento-acao',
          });
        }
        return;
      }

      this.$refs.cancelamentoDialog
        .openWithParams(
          this.$t('title.atencao'),
          this.$t('message.deseja_cancelar_edicao'),
          (ok) => {
            if (ok) {
              if (forceVoltaParaLista) {
                if (this.$route.params.from && this.$route.params.modalDashboard && this.$route.params.from === 'dashboard-inicial') {
                  this.$router.push({ name: this.$route.params.from, params: { modalDashboard: this.$route.params.modalDashboard } });
                } else {
                  this.$router.push({
                    name: 'planejamento-acao',
                  });
                }
              } else {
                this.$router.push({
                  name: this.$route.params.from || 'planejamento-acao',
                });
              }
            }
          },
        );
    },
  },
  mounted() {
  },
};
</script>
<style>
  .PlanejamentoAcaoForm_Rodape {
    height: auto !important;
    background-color: #EEEEEE;
    display: flex;
    position: fixed;
    z-index: 4;
    transform: translate(0);
    transition: all .4s cubic-bezier(.25,.8,.5,1);
    bottom: 0px;
    left: 0;
    width: 100%;
  }
  .PlanejamentoAcaoForm_Rodape .v-stepper {
    background: none;
    border: none;
    box-shadow: none;
  }
  .PlanejamentoAcaoForm_Rodape .v-stepper__header,
  .PlanejamentoAcaoForm_Rodape .v-stepper__step {
    height: 56px;
  }
  .PlanejamentoAcaoForm_Rodape__Passo {
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>
